import IService from 'core/service/IService';
import Class from 'core/util/Class';
import Logger from 'core/util/Logger';
import ServiceRegistry from '../util/ServiceRegistry';

interface IServiceArgs<T> {
	id: string;
	conditions?: object;
}

export default function Service(args?: IServiceArgs<any>): any {
	return (service: Class<IService>) => {

		// create the service
		const impl = new service();

		// get the registry for this service
		const registry = ServiceRegistry.for(service);

		Logger.debug("Registering Service: " + impl.getServiceId());

		// register the service
		registry.register(impl);

		return service;
	};
}



// WEBPACK FOOTER //
// ./src/core/decorators/Service.ts